<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view', 1)}} {{ $tc('module', 1)}} Features</div>
      <div>
        <router-link class="btn-blue" to="edit-module-features">{{ $t('edit')}}</router-link>
        <router-link
          class="btn-blue"
          to="module-features"
        >{{ $tc('module', 1)}} {{ $tc('feature', 2)}} {{ $tc('list', 2)}}</router-link>
      </div>
    </div>
    <div class="designation-details-container">
      <div class="list-container">
        <ul class="designation-details-list">
          <li>
            <div>
              <label>{{ $tc('module', 1)}} {{ $t('name') }}</label>
              <div class="details-f"></div>
            </div>
          </li>
          <li>
            <div>
              <label>Sandwich</label>
              <div class="details-f"></div>
            </div>
          </li>
          <li>
            <div>
              <label>{{ $t('active') }}</label>
              <div class="details-f"></div>
            </div>
          </li>
          <li>
            <div>
              <label>{{ $t('createdby') }}</label>
              <div class="details-f">{{ $tc('ho', 1) }} {{ $t('manager') }}</div>
            </div>
          </li>
          <li>
            <div>
              <label>{{ $t('createdat') }}</label>
              <div class="details-f">06/04/2019</div>
              <div class="details-f">12:05 AM</div>
            </div>
          </li>
          <li>
            <div>
              <label>{{ $t('modifiedby') }}</label>
              <div class="details-f">{{ $tc('ho', 1) }} {{ $t('manager') }}</div>
            </div>
          </li>
          <li>
            <div>
              <label>{{ $t('modifiedat') }}</label>
              <div class="details-f">06/04/2019</div>
              <div class="details-f">12:05 AM</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/DetailsContainer/viewModuleFeatures.vue